import React from "react";
import {Tooltip, Typography} from "antd";

const TableLongText = ({text, row=2, style = {}}) => {
    return (
        <Tooltip title={text}>
            <Typography.Paragraph ellipsis={{rows: row, expandable: false}} style={{wordBreak: 'break-all', ...style}}>
                {text}
            </Typography.Paragraph>
        </Tooltip>
    )
}

export default TableLongText